"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DomainEventHandler {
    constructor(category, logger) {
        this._evtHandlerDic = new Map();
        this._category = category;
        this._logger = logger;
    }
    registerAsyncEventHandler(evtName, asyncHandler) {
        this._evtHandlerDic.set(evtName, asyncHandler);
    }
    handleEvent(e) {
        throw new Error("Not Implemented.");
    }
    async handleEventAsync(e) {
        this._logger.debug(`${this._logger.name} Begin Handling ${e.category}.${e.name}`);
        await this.internalProcessEventAsync(e);
        this._logger.debug(`${this._logger.name} End Handling ${e.category}.${e.name}`);
    }
    async internalProcessEventAsync(domainEvent) {
        if (domainEvent.category !== this._category) {
            const error = `Not ${domainEvent.category} event=${domainEvent}`;
            this._logger.error(error);
            return;
        }
        await this.matchEventAsync(domainEvent);
    }
    async matchEventAsync(domainEvent) {
        const handler = this._evtHandlerDic.get(domainEvent.name);
        if (handler) {
            await handler(domainEvent);
        }
        else {
            this._logger.warn(`No handler for ${domainEvent.category}.${domainEvent.name}`);
        }
    }
}
exports.DomainEventHandler = DomainEventHandler;
//# sourceMappingURL=DomainEventHandler.js.map